import { Box, BoxProps, Flex, Spinner, Text } from "@chakra-ui/react";
import TextWithTooltip from "components/TextWithTooltip";
import { memo } from "react";
import { NoFieldPreviewProps } from "../fields/types";
import NoFieldPreview from "./NoFieldPreview";

interface Props extends NoFieldPreviewProps {
  title?: string;
  children?: React.ReactNode;
  isLoading?: boolean;
}

const FieldCheckboxPreviewWrapper = (props: Props & BoxProps) => {
  const {
    title,
    children,
    isLoading,
    index,
    allItemResultCount,
    prevItemResultCount,
    ...rest
  } = props;

  return (
    <Flex flexDirection="column" gap="0.5rem" {...rest}>
      <Flex
        fontWeight="bold"
        fontSize={"1.6rem"}
        gap="0.5rem"
        className="field-title"
        alignItems={"center"}
      >
        <Flex gap="0.5rem" alignItems={"center"} position={"relative"}>
          <NoFieldPreview
            index={index}
            prevItemResultCount={prevItemResultCount}
            allItemResultCount={allItemResultCount}
          />
          <TextWithTooltip
            text={title}
            textProps={{ as: "span", noOfLines: 1 }}
          />
          {isLoading && (
            <Flex
              justifyContent={"center"}
              alignItems={"center"}
              position={"absolute"}
              right={"-3rem"}
              top={0}
              w={"3rem"}
              h="100%"
              zIndex={10}
            >
              <Spinner />
            </Flex>
          )}
        </Flex>
      </Flex>
      <Box className="field-wrapper" pl="1.2rem">
        {children}
      </Box>
    </Flex>
  );
};

export default memo(FieldCheckboxPreviewWrapper);
